<div class="c-product row">
  <div class="col-10  p-0">
    <div class="titulo-producto">{{product.title}}</div>
    <div class="subtitulo-producto">{{product.subtitle}}</div>
    <ng-container *ngIf="esProductoEnVenta; else equipoEnArriendo">
      <div class="c-contenedor-tipoV">
        <div class="c-text-sub-a"> Compra de equipo</div>
      </div>
    </ng-container>
    <ng-template #equipoEnArriendo>
      <div class="c-contenedor-tipoA">
        <div class="c-text-sub"> Equipo en Arriendo</div>
      </div>
    </ng-template>
  </div>
  <div class="col-2 p-0 align-self-end" (click)="toggle()" *ngIf="!bloquearCantidad">
    <img *ngIf="!isClicked" class="icn-arrow-down c-mover-derecha" src="./assets/icons/icon-arrow-down.svg">
    <img *ngIf="isClicked" class="icn-arrow-down c-mover-derecha" src="./assets/icons/icon-arrow-up.svg">
  </div>
  <ng-container *ngIf="product.isOpen">
    <div class="col-12 c-product-detail">

      <!-- Validacion en caso que sea feria o Evento -->
      <ng-container *ngIf="this.product.evento">
        <div class="row mt-15">
          <div class="col-6 p-0 c-texto__carro--producto">Feria o Evento:<br>
            <span>{{product.evento.nombre}}</span>
          </div>
        </div>
        <hr class="mx--15">
      </ng-container>

      <!-- Validacion en caso que sea PACK -->
      <div class="row mt-15" *ngIf="!this.product.pack; else equipoPack">
        <div class="col-6 p-0 ">
          <div class="c-texto__carro--producto">Tipo de venta</div>
        </div>
        <div class="col-6 p-0 c-texto__carro--valor tex-al-right"> {{product.tipoVenta | tipoVenta}} </div>
      </div>
      <ng-template #equipoPack>
        <div class="row mt-15" *ngFor="let pack of this.product.pack; let i = index">
          <!-- Primer producto se ignora por logica de packs -->
          <ng-container *ngIf="i != 0">
            <div [ngSwitch]="pack.id" class="col-6 p-0 c-texto__carro--producto">Tipo de venta<br>
                <span *ngSwitchCase="'VENTA_MPOS_GARANTIA'">Maquinita Móvil (MPOS)</span>
                <span *ngSwitchCase="'VENTA_MPOS'">Maquinita Móvil (MPOS)</span>
                <span *ngSwitchCase="'ARRIENDO_POS_MOVIL'">SmartPOS</span>
                <span *ngSwitchCase="'LINK_PAGO'">Link de pago WebPay.cl</span>
                <span *ngSwitchDefault></span>
            </div>
            <div [ngSwitch]="pack.tipoVenta" class="col-6 p-0 c-texto__carro--valor tex-al-right">
                <span *ngSwitchCase="'SERVICIO_WEB'">Internet</span>
                <span *ngSwitchCase="'PRESENCIAL'">Presencial</span>
                <span *ngSwitchDefault></span>
            </div>
          </ng-container>
        </div>
      </ng-template>
      <ng-container *ngIf="product.tipoConexion">
        <div class="c-conection-type row mt-15" [ngSwitch]="product.tipoConexion">
          <div class="col-6 p-0 ">
            <div class="c-texto__carro--producto">Tipo de conexión</div>
          </div>
          <div class="col-6 p-0 c-texto__carro--valor tex-al-right" *ngSwitchCase="'RED_INTERNET'">Cable de internet
          </div>
          <div class="col-6 p-0 c-texto__carro--valor tex-al-right" *ngSwitchCase="'RED_CELULAR'">Chip 3G</div>
          <div class="col-6 p-0 c-texto__carro--valor tex-al-right" *ngSwitchDefault>Sin tipo</div>
        </div>
      </ng-container>
      
      <div class="row" *ngIf="this.product.rangoCantidades.length > 1">
        <div class="col-6 p-0 ">
          <div class="c-texto__carro--producto mt-15">Cantidad</div>
        </div>
        <div class="col-6 p-0 c-texto__carro--valor tex-al-right mt-15">
          <!-- input material -->
          <ng-container *ngIf="!bloquearCantidad; else soloMostrarCantidad">
            <div class="select-cantidad">
              <mat-form-field>
                <mat-select [(value)]="cantidadSeleccionada" (selectionChange)="refreshData($event)">
                  <mat-option *ngFor="let cantidad of cantidades" [value]="cantidad">{{ cantidad }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </ng-container>
          <ng-template #soloMostrarCantidad>
            <p>{{cantidadSeleccionada}}</p>
          </ng-template>
        </div>
      </div>
      <div class="row">
        <div class="col p-0 align-self-start">
        </div>
        <div class="col  p-0 align-self-end jus-right">
          <i *ngIf="!bloquearCantidad" class="icon-eliminar c-mover-derecha tex-al-right" (click)="deleteProduct()"></i>
        </div>
      </div>

      <!-- Implementacion de textos asociados a Descuentos -->
      <div *ngIf="descuentoActivo" class="c-discount-detail row">
        <div class="col-6 p-0 ">
          <div class="c-texto__carro--producto label-text mt-15">Cód. Descuento:
            <p class="discount-code-txt">{{codigoDescuento}}</p>
          </div>
        </div>
        <div class="col-6 p-0 ">
          <div class="c-texto__carro--producto discount-amount-txt mt-15">-${{ valorDescuento | thousandsPipe }}</div>
        </div>
      </div>
      <!-- FIN: Implementacion de textos asociados a Descuentos -->

    </div>
    <div class="col-12 c-garantia-detail">
      <hr class="mx--15" *ngIf="this.product.garantia != null">
      <div class="row mt-15" *ngIf="this.product.garantia != null">

        <div class="col-6 p-0 c-texto__carro--producto">Valor:</div>
        <div class="col-6 p-0 c-texto__carro--valor tex-al-right">
          <span>${{ valorPrecioProductoSinGarantia | thousandsPipe}}</span>
        </div>

        <div class="col-6 p-0 c-texto__carro--producto mt-15">Garantía {{ product.garantia.tieneGarantia == true ?
          'extendida':'base' }}:</div>
        <div class="col-6 p-0 c-texto__carro--valor tex-al-right mt-15">
          <span>${{ (product.garantia.tieneGarantia == true ? valorPrecioGarantia: '0') | thousandsPipe}}</span>
          <span *ngIf="product.garantia.tieneGarantia == false" class="sin-costo"><br>Sin Costo</span>
        </div>
      </div>
    </div>
  </ng-container>
  <div *ngIf="cont" class="conteine-blanco">
  </div>
  <div class="col-6 p-0 p ">
    <ng-container *ngIf="esProductoEnVenta; else tituloArriendo">
      <div class="c-texto__carro--valor-a   ">Total compra:
      </div>
    </ng-container>
    <ng-template #tituloArriendo>
      <div class="c-texto__carro--valor-a  ">Total cuota
        arriendo:</div>
    </ng-template>
  </div>
  <ng-container *ngIf="product.moneda !== 'PESO'; else esPeso">
    <div class="col-6 p-0">
      <div class="c-texto-valor-neto">
        <p *ngIf="valorPrecioOfertaPesos" class="offerPrice"><strong>${{ valorPrecioOfertaPesos | thousandsPipe }} <span [ngStyle]="{'font-size': (labelPrecioOferta) ? '12px' : ''}" [innerHTML]="labelPrecioOferta || '/ mes*'"></span></strong></p>
        <p class="price" [ngStyle]="{'font-size' : (valorPrecioOfertaPesos) ? '14px' : '24px'}"><strong>${{ valorProductoPeso | thousandsPipe }} <span style="font-size: 11px;" [innerHTML]="labelPrecio || '/ mes'"></span></strong></p>
        <br>IVA incluido (aprox)
      </div>
    </div>
    <div class="col-4 p-0"></div>
    <div class="col-8 p-0">
      <div class="c-texto-valor-peso">Equivalente a: {{(valorUf | number: '1.1-2' | changedot )}} UF + IVA</div>
    </div>
  </ng-container>
  <ng-template #esPeso>
    <div class="col-6 p-0">
      <div class="c-texto-valor-neto">
        <p class="price" [ngStyle]="{'font-size' : (valorPrecioOfertaPesos) ? '14px' : '24px'}"><strong>${{valorProductoPeso | thousandsPipe }}</strong></p><br>valor aprox. con IVA</div>
    </div>
    <div class="col-4 p-0"></div>
    <div class="col-8 p-0">
      <div class="c-texto-valor-peso">Equivalente a: {{(valorUf | number: '1.1-2' | changedot )}} UF + IVA</div>
    </div>
  </ng-template>
</div>